import styled, { css } from "styled-components";

import { colors } from "../../consts";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../components";
import { ComponentWrapper } from "../SearchInput/styled";

const disabledItem = css`
  pointer-events: none;
  opacity: 0.3;
`;

export const DropdownMultiselectWrapper = styled(WrapperContainer)`
  ${ComponentWrapper} {
    ${(props) => props?.active && `border: 2px solid ${colors.RAISIN_100}`}
  }
`;

export const SelectedItemWrapper = styled(FlexContainers.FlexRowStart)`
  background: rgba(52, 48, 61, 0.1);
  border: 1px solid ${colors.RAISIN_100};
  border-radius: 100px;
  gap: 12px;

  min-width: max-content;
  width: max-content;

  padding: 0 12px;
  height: 32px;

  ${(props) => props?.disabled && disabledItem}

  ${Paragraph2} {
    font-size: 14px;
    line-height: 26px;
  }
`;

export const SelectedItemsListWrapper = styled(WrapperContainer)`
  overflow-x: auto;
`;
